<template>
    <div v-if="$root.isMobile" class="mobile-page-title">
        <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-primary btn-sm" @click="showFilters = true" style="width: 80px;">
                <i class="fal fa-sliders-h"></i> Filtri
            </button>
            <h4 class="mb-0 font-weight-bold flex-grow-1 text-center">
                Pagamenti
            </h4>
            <button type="button" class="btn btn-success btn-sm d-flex justify-content-center align-items-center" @click="nuovoPagamento()" style="width: 40px; height: 31px;">
                <i class="fas fa-plus ml-2"></i>
            </button>
        </div>
    </div>
    <div class="kt-portlet__head">

        <div v-if="$root.isMobile">


            <div class="offcanvas-backdrop" :class="{ show: showFilters }" @click.self="showFilters = false">

                <aside class="offcanvas-panel" :class="{ open: showFilters }" role="dialog" aria-modal="true">
                    <div class="offcanvas-header" style="background: linear-gradient(135deg, #004B80, #00802B);">
                        <h6 class="mb-0 text-light"><i class="fal fa-filter"></i> Filtri ricerca</h6>
                        <button type="button" class="btn btn-light btn-sm" @click="showFilters = false">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>

                    <div class="offcanvas-body">
                        <form class="isprint-filter" autocomplete="off" @submit.prevent>
                            <div class="mb-3">
                                <label class="mb-1">Id Pagamento</label>
                                <input class="form-control form-control-sm" placeholder="Codice Agente"
                                    v-model="search.ID_PAGAMENTO.VALUE">
                            </div>

                            <div class="mb-3">
                                <label class="mb-1">Data Pagamento Da</label>
                                <input class="form-control form-control-sm" placeholder="Area di Competenza"
                                    v-model="search.DATA_PAGAMENTO.VALUE_FROM">
                            </div>
                            <div class="mb-3">
                                <label class="mb-1">Data Pagamento A</label>
                                <input class="form-control form-control-sm" placeholder="Area di Competenza"
                                    v-model="search.DATA_PAGAMENTO.VALUE_TO">
                            </div>

                            <div class="mb-3">
                                <label class="mb-1">Importo</label>
                                <input class="form-control form-control-sm" placeholder="Descrizione Pagamento"
                                    v-model="search.DESCRIZIONE.VALUE">
                            </div>
                            <div class="mb-3">
                                <label class="mb-1">Importo</label>
                                <input class="form-control form-control-sm" placeholder="Descrizione Agente"
                                    v-model="search.DESCRIZIONE_AGENTE.VALUE">
                            </div>
                             <div class="mb-3">
                                <label>Stato</label><br />
                                <select class="form-control form-control-sm" v-model="search.STATO.VALUE" style="width:150px">
                                    <option value="" selected>Tutti</option>
                                    <option value="0">Non elaborato</option>
                                    <option value="1">Elaborato</option>
                                </select>
                            </div>
                        </form>
                    </div>
                </aside>
            </div>
        </div>


        <form v-else class="isprint-filter" autocomplete="off" :style="{ marginBottom: $root.isTablet ? '150px' : '' }">
            <div class="form-group">
                <label>Id Pagamento</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Id Pagamento"
                    type="text" style="width:150px" v-model="search.ID_PAGAMENTO.VALUE">
            </div>
            <div class="form-group">
                <label>Agente</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Agente"
                    type="text" style="width:150px" v-model="search.DESCRIZIONE_AGENTE.VALUE">
            </div>
            <div class="form-group">
                <label>Importo</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Importo"
                    type="text" style="width:150px" v-model="search.IMPORTO.VALUE">
            </div>
            <div class="form-group"> <label>Data Pagamento Da</label><br />
                <DatePicker placeholder="Data inizio" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_PAGAMENTO.VALUE_FROM">
                </DatePicker>
            </div>
            <div class="form-group"> <label>Data Pagamento A</label><br />
                <DatePicker placeholder="Data fine" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_PAGAMENTO.VALUE_TO">
                </DatePicker>
            </div>
            <div class="form-group">
                <label>Descrizione</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Descrizione"
                    type="text" style="width:150px" v-model="search.DESCRIZIONE.VALUE">
            </div>
            <div class="form-group">
                <label>Stato</label><br />
                <select class="form-control form-control-sm" v-model="search.STATO.VALUE" style="width:150px">
                    <option value="" selected>Tutti</option>
                    <option value="0">Non elaborato</option>
                    <option value="1">Elaborato</option>
                </select>
            </div>
            <div class="form-group float-right">
                <button class="btn btn-success float-right btn-sm " v-on:click="nuovoPagamento()"
                    style="margin-top:26px"><i class="fal fa-plus"></i> Nuovo Pagamento</button>
            </div>
        </form>
    </div>
    <div class="isprint-grid-container">
        <div v-if="$root.isMobile" class="row justify-content-center">
            <div class="col-12 mb-4" v-for="pagamento in paginatedList.arr" :key="pagamento.ID_PAGAMENTO">
                <div class="card shadow border-0 text-center p-3" style="border-radius: 20px;">
                    <div class="card-body">
                        <i class="fad fa-euro-sign fa-6x  mb-3" aria-hidden="true"></i>

                        <h5 class="card-title">Pagamento a {{ pagamento.DESCRIZIONE_AGENTE }}</h5>

                        <p class="mb-1"><strong>Importo:</strong> {{ pagamento.IMPORTO }} €</p>
                        <p class="mb-1"><strong>Data Pagamento:</strong> {{ filters.formatDateTime(pagamento.DATA_PAGAMENTO) || '—' }}</p>
                        <p class="mb-1"><strong>Descrizione:</strong> {{ pagamento.DESCRIZIONE }}</p>


                        <div
                            :class="['d-flex', 'mt-3', pagamento.STATO == 1 ? 'justify-content-center' : 'justify-content-between']">


                            <button v-if="pagamento.STATO == 0" class="btn btn-warning btn-sm"
                                @click="modificaPagamento(pagamento)" title="Modifica pagamento">
                                <i class="fal fa-pencil"></i>
                            </button>

                            <ISwitch v-model="pagamento.STATO" @toggle="updateStato(pagamento)" :size="'sm'"
                                style="margin-top:6px"></ISwitch>

                            <button v-if="pagamento.STATO == 0" class="btn btn-danger btn-sm"
                                @click="eliminaPagamento(pagamento)" title="Elimina Pagamento">
                                <i class="fal fa-trash-alt"></i>
                            </button>

                        </div>


                    </div>
                </div>
            </div>
        </div>

        <table v-else class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="left: 0px; background: linear-gradient(135deg, #004B80, #00802B); color:#fff;">
                    <th style="width:10%"><span>Id Pagamento</span></th>
                    <th style="width:20%"><span>Agente</span></th>
                    <th style="width:10%"><span>Importo</span></th>
                    <th style="width:20%"><span>Data Pagamento</span></th>
                    <th style="width:20%"><span>Descrizione</span></th>
                    <th style="width:10%"><span>Stato</span></th>
                    <th style="width:10%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-for="pagamento in paginatedList.arr"
                    v-bind:key="pagamento.ID_PAGAMENTO">
                    <td style="width:10%">
                        <kbd style="font-size:16px">{{ pagamento.ID_PAGAMENTO }}</kbd>
                    </td>
                    <td style="width:20%">
                        <span>
                            <i class="fad fa-user-secret fa-2x mr-2" aria-hidden="true"></i>
                            <strong>{{ pagamento.DESCRIZIONE_AGENTE != null ? pagamento.DESCRIZIONE_AGENTE : 'Nessun Agente Associato'}}</strong>
                        </span>
                    </td>
                    <td style="width:10%">
                        <strong>{{ pagamento.IMPORTO }}</strong> <i class="fad fa-euro-sign"></i>
                    </td>
                    <td style="width:20%">
                        <i class="fad fa-calendar-day fa-2x mr-2"></i>
                        {{ filters.formatDateTime(pagamento.DATA_PAGAMENTO) }}
                    </td>
                    <td style="width:20%">
                        {{ pagamento.DESCRIZIONE }}
                    </td>
                    <td style="width:10%; display: flex; align-items: center; justify-content: space-between;">

                        <span style="margin-top: 12px;" class="badge badge-success"
                            v-if="pagamento.STATO == 1">Saldato</span>
                        <span style="margin-top: 12px;" class="badge badge-danger" v-else-if="pagamento.STATO == 0">Da
                            Saldare</span>
                        <span style="margin-left: 12px;">
                            <ISwitch style="margin-top: 12px;" v-model="pagamento.STATO"
                                @toggle="updateStato(pagamento)" :size="'sm'"></ISwitch>
                        </span>

                    </td>

                    <td style="width:10%; ">
                        <div v-if="pagamento.STATO != 1" class="btn-group float-right" role="group"
                            aria-label="Basic example">
                            <button data-toggle="tooltip" data-placement="top" title="Modifica pagamento"
                                class="btn btn-warning btn-sm float-right" v-on:click="modificaPagamento(pagamento)"><i
                                    class="fal fa-pencil"></i></button>
                            <button data-toggle="tooltip" data-placement="top" title="Elimina pagamento"
                                class="btn btn-danger btn-sm float-right" v-on:click="deletePagamento(pagamento)"><i
                                    class="fal fa-trash-alt"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>

    <!-- MODALE  -->
    <div class="modal fade" id="popUpPagamento" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background: linear-gradient(135deg, #004B80, #00802B);">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-euro-sign fa-fw"></i> Pagamento</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="$root.isMobile" class="row">
                        <div class="col-7">
                            <div class="form-group">
                                <label>Agente:</label>
                                <Select2 v-model="pagamentoSelezionato.FK_ID_AGENTE" :w="150"
                                    :api="'dcp/agente/select2?a=1'" :apiselected="'dcp/agente/s2'">
                                </Select2>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="form-group">
                                <label>Importo:</label>
                                <input type="text" class="form-control form-control-sm" placeholder="Inserisci Importo"
                                    v-model="pagamentoSelezionato.IMPORTO">
                            </div>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>Agente:</label>
                                <Select2 v-model="pagamentoSelezionato.FK_ID_AGENTE" :w="221"
                                    :api="'dcp/agente/select2?a=1'" :apiselected="'dcp/agente/s2'"></Select2>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label>Importo:</label>
                                <input type="text" class="form-control form-control-sm" placeholder="Inserisci Importo"
                                    v-model="pagamentoSelezionato.IMPORTO">
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <ISwitch style="margin-top: 12px;" v-model="pagamentoSelezionato.STATO" :size="'sm'"></ISwitch>
                        <br>
                        <span style="margin-top: 12px; display: block;"
                            :class="{ 'badge badge-success': pagamentoSelezionato.STATO == 1, 'badge badge-danger': pagamentoSelezionato.STATO == 0 }">
                            {{ pagamentoSelezionato.STATO == 1 ? 'Saldato' : 'Da Saldare' }}
                        </span>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>Descrizione</label>
                                <textarea v-model="pagamentoSelezionato.DESCRIZIONE" class="form-control"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaPagamento()"><i
                            class="fa fa-check"></i>
                        Salva</button>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'
import Select2 from '@/components/utils/Select2.vue'
import DatePicker from '@/components/utils/DatePicker.vue'
import ISwitch from '../components/utils/ISwitch.vue';



export default {
    name: "Pagamenti",
    components: {
        Pagine,
        Select2,
        DatePicker,
        ISwitch
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                ID_PAGAMENTO: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE_AGENTE: { TYPE: 'TEXT', VALUE: '' },
                DATA_PAGAMENTO: { TYPE: 'DATE_RANGE', VALUE_FROM: '', VALUE_TO: '' },
                IMPORTO: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
                STATO: { TYPE: 'COMBO', VALUE: '' },
            },
            arrayPagamenti: new Array(),
            pagamentoSelezionato: {},
            showFilters: false,
        }
    },
    methods: {
        updateStato: function (pagamento) {
            global.utils.put('/dcp/pagamento/stato', { ID_PAGAMENTO: pagamento.ID_PAGAMENTO, STATO: pagamento.STATO }, (response) => {
                if (response.esito == 0) {
                    utils.alert.success(response.messaggio);
                    this.getPagamenti();
                }
            });
        },
        getPagamenti: function () {
            global.utils.get('/dcp/pagamenti', {}, (response) => {
                this.arrayPagamenti = response.data;
            });
        },
        nuovoPagamento: function () {
            this.pagamentoSelezionato = { ID_PAGAMENTO: 0, STATO: 1 }
            var modal = utils.openModal('popUpPagamento');
        },
        modificaPagamento: function (agente) {
            this.pagamentoSelezionato = utils.clone(agente);
            var modal = utils.openModal('popUpPagamento');
        },
        deletePagamento: function (agente) {
            utils.alert.confirm("Sei sicuro di voler eliminare il pagamento selezionato?", () => {
                global.utils.delete('/dcp/pagamento', { ID_PAGAMENTO: agente.ID_PAGAMENTO }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getPagamenti();
                    }
                });
            }, this.$root);
        },
        salvaPagamento: function () {
            this.pagamentoSelezionato.IMPORTO = this.filters.formatWithCommas(this.pagamentoSelezionato.IMPORTO)
            if (this.pagamentoSelezionato.IMPORTO == null || this.pagamentoSelezionato.IMPORTO.trim() == '') {
                utils.alert.warning("Inserire Importo e Selezionare Agente");
                return;
            }
            if (this.pagamentoSelezionato.FK_ID_AGENTE == null) {
                utils.alert.warning("Inserire Importo e Selezionare Agente");
                return;
            }
            if (isNaN(parseFloat(this.pagamentoSelezionato.IMPORTO)) || this.pagamentoSelezionato.IMPORTO === '') {
                utils.alert.warning("L'importo deve essere numerico");
                return;
            }
             if (isNaN(parseFloat(this.pagamentoSelezionato.IMPORTO)) ||  this.pagamentoSelezionato.IMPORTO == 0) {
                utils.alert.warning("L'importo deve essere diverso da 0");
                return;
            }
            if (this.pagamentoSelezionato.ID_PAGAMENTO > 0) {
                global.utils.put('/dcp/pagamento', this.pagamentoSelezionato, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getPagamenti();
                        utils.closeModal('popUpPagamento');
                    }
                });
            }
            else {
                global.utils.post('/dcp/pagamento', this.pagamentoSelezionato, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getPagamenti();
                        utils.closeModal('popUpPagamento');
                    }
                });
            }
        }

    },
    computed: {
        paginatedList() {
            var arr = utils.inGrid(this.arrayPagamenti, this.search);
            return arr;
        },
    },
    created: function () {
        this.getPagamenti();
    },
}
</script>
<style scoped>
.offcanvas-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .15);
    opacity: 0;
    visibility: hidden;
    transition: opacity .2s ease, visibility .2s ease;
    z-index: 1040;
}

.offcanvas-backdrop.show {
    opacity: 1;
    visibility: visible;
}

.offcanvas-panel {
    position: fixed;
    top: 0;
    right: -100%;
    height: 100vh;
    width: 88%;
    max-width: 420px;
    background: #fff;
    box-shadow: -6px 0 24px rgba(0, 0, 0, .15);
    z-index: 1050;
    display: flex;
    flex-direction: column;
    transition: right .25s ease;
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
}

.offcanvas-panel.open {
    right: 0;
}

.offcanvas-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .75rem 1rem;
    border-bottom: 1px solid #eee;
}

.offcanvas-body {
    flex: 1;
    padding: 1rem;
    overflow-y: auto;
}

/* Quando la larghezza della finestra è maggiore o uguale a 1229px */
@media (min-width: 1230px) {
    .isprint-grid-container {
        margin-top: 20px;
        width: auto;
        table-layout: auto;
    }
}

/* Quando la larghezza della finestra è inferiore a 1396px */
@media (max-width: 1229px) {
    .isprint-grid-container {
        margin-top: 100px;
    }
}

.mobile-page-title {
    padding: 15px;
    background: linear-gradient(135deg, #004B80, #00802B);
    color: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 100;
}

.mobile-page-title h4 {
    margin: 0;
    color: white;
}

.mobile-page-title i {
    margin-right: 8px;
}

/* Nascondi il portlet head in mobile visto che è vuoto */
@media (max-width: 767px) {
    .kt-portlet__head {
        height: 0 !important;
        overflow: hidden;
    }
}
</style>
